import React, { useContext, useEffect, useRef, useState } from "react"

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "gatsby"

import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import "swiper/components/scrollbar/scrollbar.scss"
import { Modal, Button } from "react-bootstrap"

// Import Swiper styles
import "swiper/swiper.scss"

import { StaticImage } from "gatsby-plugin-image"

import bg1 from "../../images/inside-bg-1.jpg"
import bg2 from "../../images/inside-bg-2.jpg"
import bg3 from "../../images/inside-bg-3.jpg"
import bg4 from "../../images/inside-bg-4.jpg"
import bg5 from "../../images/inside-bg-5.jpg"
import play from "../../images/play-button.png"

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const InsideFluoSwiper = () => {
  // const [isHide, setIsHide] = useState(true)

  // const playButton = () => {
  //   setIsHide(false)
  // }

  // const [isHide1, setIsHide1] = useState(true)

  // const playButton1 = () => {
  //   setIsHide1(false)
  // }

  // const [isHide2, setIsHide2] = useState(true)

  // const playButton2 = () => {
  //   setIsHide2(false)
  // }

  // const [isHide3, setIsHide3] = useState(true)

  // const playButton3 = () => {
  //   setIsHide3(false)
  // }

  // const [isHide4, setIsHide4] = useState(true)

  // const playButton4 = () => {
  //   setIsHide4(false)
  // }

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [show2, setShow2] = useState(false)

  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)

  const [show3, setShow3] = useState(false)

  const handleClose3 = () => setShow3(false)
  const handleShow3 = () => setShow3(true)

  const [show4, setShow4] = useState(false)

  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)

  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      loop={true}
      // autoplay={{
      //   delay: 5000,
      //   disableOnInteraction: false,
      // }}
      navigation
      onSwiper={swiper => console.log(swiper)}
      onSlideChange={() => console.log("slide change")}
      className="hero"
    >
      <div className="liquid-left"></div>
      {/* <SwiperSlide
        className="hero-inside-swiper"
        style={{ backgroundImage: `url(${bg1})` }}
      >
        <div className="hero-slider video-thumbnail-inside-fluo">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mx-auto mt-2">
                <div className="text-center align-items-center">
                  <div className="hero-content text-white">
                    <Button onClick={handleShow} className="inside-modal-cta">
                      <img
                        className="img-fluid inside-playbutton"
                        src={play}
                        alt="Play Button"
                      />
                    </Button>
                    <h1 className="hero-title mb-4 text-italic">Rally Cry</h1>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      dialogClassName="inside-popup"
                      centered
                    >
                      <button className="close-btn" onClick={handleClose}>
                        <i className="fa fa-times" />
                      </button>
                      <Modal.Body>
                        <iframe
                          width="100%"
                          height="600"
                          src="https://player.vimeo.com/video/669697503?h=1577fe2ff7?&autoplay=1&title=0&byline=0"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide> */}
      <SwiperSlide
        className="hero-inside-swiper"
        style={{ backgroundImage: `url(${bg2})` }}
      >
        <div className="hero-slider video-thumbnail-inside-fluo">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mx-auto mt-2">
                <div className="text-center align-items-center">
                  <div className="hero-content text-white">
                    <Button onClick={handleShow} className="inside-modal-cta">
                      <img
                        className="img-fluid inside-playbutton"
                        src={play}
                        alt="Play Button"
                      />
                    </Button>
                    <h1 className="hero-title mb-4 text-italic">
                      What is FLUO?
                    </h1>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      dialogClassName="inside-popup"
                      centered
                    >
                      <button className="close-btn" onClick={handleClose}>
                        <i className="fa fa-times" />
                      </button>
                      <Modal.Body>
                        <iframe
                          width="100%"
                          height="600"
                          src="https://player.vimeo.com/video/669697541?h=4609058cb4?&autoplay=1&title=0&byline=0"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div class="embed-responsive embed-responsive-16by9">
          <iframe
            src=""
            allow="autoplay"
            allowfullscreen
            frameborder="0"
            className="inside-fluo-iframe"
          ></iframe>
        </div> */}
      </SwiperSlide>
      <SwiperSlide
        className="hero-inside-swiper"
        style={{ backgroundImage: `url(${bg3})` }}
      >
        <div className="hero-slider video-thumbnail-inside-fluo">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mx-auto mt-2">
                <div className="text-center align-items-center">
                  <div className="hero-content text-white">
                    <Button onClick={handleShow2} className="inside-modal-cta">
                      <img
                        className="img-fluid inside-playbutton"
                        src={play}
                        alt="Play Button"
                      />
                    </Button>
                    <h1 className="hero-title mb-4 text-italic">Why FLUO?</h1>
                    <Modal
                      show={show2}
                      onHide={handleClose2}
                      dialogClassName="inside-popup"
                      centered
                    >
                      <button className="close-btn" onClick={handleClose2}>
                        <i className="fa fa-times" />
                      </button>
                      <Modal.Body>
                        <iframe
                          width="100%"
                          height="600"
                          src="https://player.vimeo.com/video/669697562?h=9335a8bebb?&autoplay=1&title=0&byline=0"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div class="embed-responsive embed-responsive-16by9">
            <iframe
              src=""
              width="100%"
              height="564"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
              className="inside-fluo-iframe"
            ></iframe>
          </div> */}
      </SwiperSlide>
      <SwiperSlide
        className="hero-inside-swiper"
        style={{ backgroundImage: `url(${bg4})` }}
      >
        <div className="hero-slider video-thumbnail-inside-fluo">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mx-auto mt-2">
                <div className="text-center align-items-center">
                  <div className="hero-content text-white">
                    <Button onClick={handleShow3} className="inside-modal-cta">
                      <img
                        className="img-fluid inside-playbutton"
                        src={play}
                        alt="Play Button"
                      />
                    </Button>
                    <h1 className="hero-title mb-4 text-italic">
                      What is the FLUO Foundation?
                    </h1>
                    <Modal
                      show={show3}
                      onHide={handleClose3}
                      dialogClassName="inside-popup"
                      centered
                    >
                      <button className="close-btn" onClick={handleClose3}>
                        <i className="fa fa-times" />
                      </button>
                      <Modal.Body>
                        <iframe
                          width="100%"
                          height="600"
                          src="https://player.vimeo.com/video/669697476?h=505dd421a6?h=9335a8bebb?&autoplay=1&title=0&byline=0"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div class="embed-responsive embed-responsive-16by9">
            <iframe
              src=""
              allow="autoplay"
              allowfullscreen
              frameborder="0"
              className="inside-fluo-iframe"
            ></iframe>
          </div> */}
      </SwiperSlide>
      <SwiperSlide
        className="hero-inside-swiper"
        // onClick={playButton4}
        style={{ backgroundImage: `url(${bg5})` }}
      >
        {/* {isHide4 ? ( */}
        <div className="hero-slider video-thumbnail-inside-fluo">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mx-auto mt-2">
                <div className="text-center align-items-center">
                  <div className="hero-content text-white">
                    <Button onClick={handleShow4} className="inside-modal-cta">
                      <img
                        className="img-fluid inside-playbutton"
                        src={play}
                        alt="Play Button"
                      />
                    </Button>
                    <h1 className="hero-title mb-4 text-italic">
                      The FLUO Emblem
                    </h1>
                    <Modal
                      show={show4}
                      onHide={handleClose4}
                      dialogClassName="inside-popup"
                      centered
                    >
                      <button className="close-btn" onClick={handleClose4}>
                        <i className="fa fa-times" />
                      </button>
                      <Modal.Body>
                        <iframe
                          width="100%"
                          height="600"
                          src="https://player.vimeo.com/video/669697489?h=79a706336f?h=9335a8bebb?&autoplay=1&title=0&byline=0"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : ( */}
        {/* <div class="embed-responsive embed-responsive-16by9">
            <iframe
              src=""
              allow="autoplay"
              allowfullscreen
              frameborder="0"
              className="inside-fluo-iframe"
            ></iframe>
          </div> */}
        {/* )} */}
      </SwiperSlide>
      <div className="liquid-right"></div>
    </Swiper>
  )
}

export default InsideFluoSwiper
